<template>
  <div>
    <ui-list
        :headings="[
        $tc('models.company'),
        $tc('models.role'),
        // ''
      ]"
        :sort="[
        { prop: 'companyName', type: false },
      ]"
        :items="companyUsers"
    >
      <template v-slot:default="props">
        <!-- Company name -->
        <ui-list-data :text="props.item.companyName" />
        <!-- Role -->
        <ui-list-data type="tag" :text="$t('roles.CompanyAdmin')" />
      </template>
    </ui-list>
  </div>
</template>

<script>
import UiList from "../../../components/ui/UiList";
import UiListData from "../../../components/ui/UiListData";

export default {
  name: "BuildingConnections",

  components: {
    UiList,
    UiListData,
  },

  props: {
    companyUsers: {
      type: Array,
      required: true
    }
  },

  data() {
    return {

    }
  },

  methods: {

    /****************
     * Delete Section
     ***************/

  },
}
</script>

<style scoped>

</style>
